export default __webpack_public_path__ + "static/media/loginbg.da17b550.jpg";